


import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import PersonalDataForm from "../../../../forms/shared/PersonalDataForm";

import TmpInputCustom, { InputMaskProps } from "../../../../components/tempo/TmpInputCustom/TmpInputCustom";

import DadosPessoaisService from "../../../../services/PersonalDataService";
import TmpDatepickerCustom from "../../../../components/tempo/TmpDatepickerCustom/TmpDatepickerCustom";
import TmpInputSelectCustom from "../../../../components/tempo/TmpInputSelectCustom/TmpInputSelectCustom";
import TmpInputSelectMultiCustom from "../../../../components/tempo/TmpInputSelectMultiCustom/TmpInputSelectMultiCustom";
import TmpInputPhoneCustom from "../../../../components/tempo/TmpInputPhoneCustom/TmpInputPhoneCustom";


interface PersonalDataComponentProps {
    PersonalDataForm: PersonalDataForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
}

/* eslint-disable no-useless-escape */
export default function PersonalDataComponent(props: PersonalDataComponentProps) {


    const [civilStateOptions, setCivilStateOptions] = useState([])
    const [languageStateOptions, setLanguageStateOptions] = useState([])
    const [colorSkinOptions, setColorSkingOptions] = useState([])
    const [nationalityOptions, setNationalityOptions] = useState([])
    const [sexOptions, setSexOptions] = useState([])

    useEffect(() => {
        DadosPessoaisService.getAllMaritalStatusOptions().then(e => setCivilStateOptions(e))
        DadosPessoaisService.getAllLanguageOptions().then(e => setLanguageStateOptions(e))
        DadosPessoaisService.GetAllColorSkinOptions().then(e => setColorSkingOptions(e))
        DadosPessoaisService.GetAllNationality().then(e => setNationalityOptions(e))
        DadosPessoaisService.GetAllSexOptions().then(e => setSexOptions(e))
    }, []);


    return (
        <>
            <Grid container spacing={3} >
                <Grid item sm={12} md={8} lg={6} xl={6}  >
                    <TmpInputCustom
                        id="Name"
                        name="Name"
                        label="Nome Completo *"
                        maxLength={60}
                        placeholder="Digite o seu nome completo"
                        value={props.PersonalDataForm.Name.Value}
                        type="text"
                        onChange={(e) => {
                            e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                            props.onInputChange("Name", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("Name", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.Name.HasError()}
                        helperText={props.PersonalDataForm.Name.Error}
                    />
                </Grid>
                <Grid item sm={12} md={4} lg={3} xl={3}>
                    <TmpInputCustom
                        id="CPF"
                        name="CPF"
                        label="CPF *"
                        maxLength={14}
                        mask={InputMaskProps.CPF}
                        placeholder="000.000.000-00"
                        value={props.PersonalDataForm.CPF.Value}
                        type="text"
                        onChange={(e) => {
                            props.onInputChange("CPF", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("CPF", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.CPF.HasError()}
                        helperText={props.PersonalDataForm.CPF.Error}
                    />
                </Grid>

                <Grid item sm={12} md={4} lg={3} xl={3}>
                    <TmpDatepickerCustom
                        name="BirthDate"
                        maxDate={new Date()}
                        label="Data de Nascimento *"
                        placeholder="00/00/0000"
                        value={props.PersonalDataForm.BirthDate.Value}
                        onChange={(e) => {
                            props.onInputChange("BirthDate", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("BirthDate", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.BirthDate.HasError()}
                        helperText={props.PersonalDataForm.BirthDate.Error}
                    />
                </Grid>

                <Grid item sm={12} md={4} lg={4} xl={4}>
                    <TmpInputCustom
                        id="CRM"
                        name="CRM"
                        label="Número do Conselho *"
                        maxLength={20}
                        type="text"
                        placeholder="Digite o número do conselho"
                        helperIcon="error"
                        value={props.PersonalDataForm.CRM.Value}
                        helperText={props.PersonalDataForm.CRM.Error}
                        onChange={(e) => {
                            e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\=?;:'",¨<>\{\}\[\]\\\/]/gi, '');
                            props.onInputChange("CRM", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("CRM", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.CRM.HasError()}
                    />
                </Grid>
                <Grid item sm={12} md={4} lg={4} xl={4}>
                    <TmpInputCustom
                        id="RG"
                        name="RG"
                        label="RG *"
                        maxLength={15}
                        type="text"
                        placeholder="Digite o Número do RG"
                        helperIcon="error"
                        value={props.PersonalDataForm.RG.Value}
                        onChange={(e) => {
                            e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\=?;:'",¨<>\{\}\[\]\\\/]/gi, '');
                            props.onInputChange("RG", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("RG", props.PersonalDataForm, e.target.value);
                        }}
                        helperText={props.PersonalDataForm.RG.Error}
                        error={props.PersonalDataForm.RG.HasError()}
                    />
                </Grid>
                <Grid item sm={12} md={4} lg={4} xl={4} >
                    <TmpInputCustom
                        label="Orgão Emissor *"
                        name="OM"
                        id="OM"
                        maxLength={40}
                        type="text"
                        placeholder="Informe o Orgão Emissor"
                        value={props.PersonalDataForm.OM.Value}
                        onChange={(e) => {
                            props.onInputChange("OM", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("OM", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.OM.HasError()}
                        helperText={props.PersonalDataForm.OM.Error}
                    />
                </Grid>

                <Grid item sm={12} md={4} lg={4} xl={4} >
                    <TmpInputSelectCustom
                        label="Estado Civil *"
                        name="MaritalStatus"
                        id="MaritalStatus"
                        placeholder="Selecione"
                        itens={civilStateOptions}
                        value={props.PersonalDataForm.MaritalStatus.Value}
                        onChange={(e) => {
                            props.onInputChange("MaritalStatus", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("MaritalStatus", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.MaritalStatus.HasError()}
                        helperText={props.PersonalDataForm.MaritalStatus.Error}
                    />
                </Grid>
                <Grid item sm={12} md={4} lg={4} xl={4} >
                    <TmpInputSelectCustom
                        label="Cor *"
                        name="ColorSkin"
                        id="ColorSkin"
                        placeholder="Selecione"
                        itens={colorSkinOptions}
                        value={props.PersonalDataForm.ColorSkin.Value}
                        onChange={(e) => {
                            props.onInputChange("ColorSkin", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("ColorSkin", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.ColorSkin.HasError()}
                        helperText={props.PersonalDataForm.ColorSkin.Error}
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={4} xl={4}  >
                    <TmpInputSelectCustom
                        label="Sexo *"
                        name="Sex"
                        id="Sex"
                        placeholder="Selecione"
                        itens={sexOptions}
                        value={props.PersonalDataForm.Sex.Value}
                        onChange={(e) => {
                            props.onInputChange("Sex", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("Sex", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.Sex.HasError()}
                        helperText={props.PersonalDataForm.Sex.Error}
                    />
                </Grid>

                <Grid item sm={12} md={6} lg={5} xl={5}  >
                    <TmpInputSelectCustom
                        label="Nacionalidade *"
                        name="Nationality"
                        id="Nationality"
                        placeholder="Selecione"
                        itens={nationalityOptions}
                        value={props.PersonalDataForm.Nationality.Value}
                        onChange={(e) => {
                            props.onInputChange("Nationality", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("Nationality", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.Nationality.HasError()}
                        helperText={props.PersonalDataForm.Nationality.Error}
                    />
                </Grid>

                <Grid item sm={12} md={12} lg={7} xl={7} >

                    <TmpInputSelectMultiCustom
                        label="Idiomas que domina"
                        name="Language"
                        id="Language"
                        placeholder={"Digite os idiomas que você domina"}
                        value={props.PersonalDataForm.Language.Value}
                        itens={languageStateOptions}
                        onChange={(e) => {
                            props.onInputChange("Language", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("Language", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.Language.HasError()}
                        helperText={props.PersonalDataForm.Language.Error}
                    />

                </Grid>

                <Grid item sm={12} md={6} lg={6} xl={6}  >
                    <TmpInputCustom
                        id="MotherName"
                        name="MotherName"
                        label="Nome da Mãe"
                        maxLength={60}
                        placeholder="Digite o nome da Mãe"
                        value={props.PersonalDataForm.MotherName.Value}
                        type="text"
                        onChange={(e) => {
                            props.onInputChange("MotherName", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("MotherName", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.MotherName.HasError()}
                        helperText={props.PersonalDataForm.MotherName.Error}

                    />
                </Grid>
                <Grid item sm={12} md={6} lg={6} xl={6}  >
                    <TmpInputCustom
                        id="FatherName"
                        name="FatherName"
                        label="Nome do Pai"
                        maxLength={60}
                        placeholder="Digite o nome do Pai"
                        value={props.PersonalDataForm.FatherName.Value}
                        type="text"
                        onChange={(e) => {
                            props.onInputChange("FatherName", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("FatherName", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.FatherName.HasError()}
                        helperText={props.PersonalDataForm.FatherName.Error}

                    />
                </Grid>

                <Grid item sm={12} md={6} lg={6} xl={6}  >
                    <TmpInputCustom
                        id="PartnerName"
                        name="PartnerName"
                        label="Cônjuge"
                        maxLength={60}
                        placeholder="Digite o nome do Cônjuge"
                        value={props.PersonalDataForm.PartnerName.Value}
                        type="text"
                        onChange={(e) => {
                            props.onInputChange("PartnerName", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("PartnerName", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.PartnerName.HasError()}
                        helperText={props.PersonalDataForm.PartnerName.Error}

                    />
                </Grid>
                <Grid item sm={12} md={6} lg={6} xl={6}  >
                    <TmpInputCustom
                        id="UsualName"
                        name="UsualName"
                        label="Nome usual (crachá) *"
                        maxLength={60}
                        placeholder="Digite seu nome usual, que vai aparecer no seu crachá"
                        value={props.PersonalDataForm.UsualName.Value}
                        type="text"
                        onChange={(e) => {
                            props.onInputChange("UsualName", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("UsualName", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.UsualName.HasError()}
                        helperText={props.PersonalDataForm.UsualName.Error}

                    />
                </Grid>


                <Grid item sm={12} md={6} lg={4} xl={4}  >
                    <TmpInputPhoneCustom
                        id="CellPhone"
                        name="CellPhone"
                        label="Celular *"
                        placeholder="(00) 00000-0000"
                        placeholderDDI="+00"
                        value={props.PersonalDataForm.CellPhone.Value}
                        type="mobile"
                        onChange={(e) => {
                            props.onInputChange("CellPhone", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("CellPhone", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.CellPhone.HasError()}
                        helperText={props.PersonalDataForm.CellPhone.Error}

                    />
                </Grid>
                <Grid item sm={12} md={6} lg={4} xl={4}>
                    <TmpInputPhoneCustom
                        id="TelephonePhone"
                        name="TelephonePhone"
                        label="Telefone Fixo"
                        placeholder="(00) 0000-0000"
                        placeholderDDI="+00"
                        value={props.PersonalDataForm.TelephonePhone.Value}
                        type="phone"
                        onChange={(e) => {
                            props.onInputChange("TelephonePhone", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("TelephonePhone", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.TelephonePhone.HasError()}
                        helperText={props.PersonalDataForm.TelephonePhone.Error}
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={4} xl={4}>
                    <TmpInputPhoneCustom
                        id="BusinessPhone"
                        name="BusinessPhone"
                        label="Telefone Comercial"
                        placeholder="(00) 00000-0000"
                        placeholderDDI="+00"
                        value={props.PersonalDataForm.BusinessPhone.Value}
                        type="phone"
                        onChange={(e) => {
                            props.onInputChange("BusinessPhone", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("BusinessPhone", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.BusinessPhone.HasError()}
                        helperText={props.PersonalDataForm.BusinessPhone.Error}

                    />

                </Grid>

                <Grid item sm={12} md={6} lg={6} xl={6}>
                    <TmpInputCustom
                        id="Email"
                        name="Email"
                        label="E-mail *"
                        maxLength={255}
                        placeholder="Digite seu e-mail"
                        value={props.PersonalDataForm.Email.Value}
                        type="text"
                        onChange={(e) => {
                            props.onInputChange("Email", props.PersonalDataForm, e.target.value);
                        }}
                        onBlur={(e) => {
                            props.onInputChange("Email", props.PersonalDataForm, e.target.value);
                        }}
                        error={props.PersonalDataForm.Email.HasError()}
                        helperText={props.PersonalDataForm.Email.Error}

                    />
                </Grid>

            </Grid>
        </>
    )

}